'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-1887e1af.js');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var Title2 = styled__default["default"].span(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  font-family: ", ";\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  letter-spacing: ", ";\n"], ["\n  font-family: ", ";\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  letter-spacing: ", ";\n"])), function (_a) {
    var primary = _a.theme.fonts.primary;
    return primary;
}, function (_a) {
    var primary = _a.theme.colors.text.primary;
    return primary;
}, function (_a) {
    var font_size = _a.theme.typography.title_2.font_size;
    return font_size;
}, function (_a) {
    var font_weight = _a.theme.typography.title_2.font_weight;
    return font_weight;
}, function (_a) {
    var line_height = _a.theme.typography.title_2.line_height;
    return line_height;
}, function (_a) {
    var letter_spacing = _a.theme.typography.title_2.letter_spacing;
    return letter_spacing;
});
Title2.propTypes = {};
var templateObject_1;

exports["default"] = Title2;
